import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChangeAssignmentDate } from '../../model/changeassignmentdate';
import { EditLogInfo } from '../../model/editloginfo';
import { AssignmentService } from '../../shared/assignment.service';
import { ChangelogService } from '../../shared/changelog.service';
import { CommonService } from '../../shared/common.service';
import { ReturnObject } from '../../model/returnobject';
import { UserService } from '../../shared/user.service';
import { User } from '../../model/user';
import { StatusMessagesService } from '../../shared/statusmessage.service';

@Component({
  selector: 'extend-date-dialog',
  templateUrl: 'extend-date-dialog.html',
  styleUrls: ['./extend-date-dialog.scss']
})
export class ExtendDateDialog implements OnInit {
  @Input() assignmentNumber: string = '';
  @Input() department: string = '';
  @Input() assignmentManager: string = '';
  @Input() showMe: boolean = false;
  @Input() isDateSet: boolean = false;
  @Output() onCloseDlg: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  showLoading: boolean = false;
  dataChanged: boolean = false;
  loggedUser: User = new User();
  logChangesList: EditLogInfo[] = [];
  todaysDate = new Date().toISOString().split('T')[0];
  extendtoDate: string = '';

  constructor(
    private common: CommonService,
    private assignmentApi: AssignmentService,
    private changeLogApi: ChangelogService,
    private userService: UserService,
    private statusMessagesService: StatusMessagesService
  ) { }

  ngOnInit() {
    this.initServices();
  }

  initServices() {
    this.showLoading = true;
    this.loggedUser = this.userService.getUser();
    this.getChanges();
  }
  getChanges() {
    this.showLoading = true;
    this.changeLogApi.getChanges(this.assignmentNumber, 'Edit Extend Date')
      .subscribe({
            next: (res: ReturnObject<EditLogInfo[]>) => {
              if (res.isFailure) {
                this.statusMessagesService.showToasterError('Error', 'Failed to load History');
                return;
              }
      
              this.logChangesList = res.value;
            },
            error: (err) => {         
              this.statusMessagesService.showHttpError(err);
            },
            complete: () => {         
                this.showLoading = false;
            }
        }
    );
  }

  setAssignmentExtendDate() {
    var dateToExtend = new Date(this.extendtoDate);
    this.showLoading = true;

    this.assignmentApi.setAssignmentExtendDate(new ChangeAssignmentDate(this.assignmentNumber, dateToExtend))
      .subscribe({
            next: (res: ReturnObject<string>) => {
              if (res.isFailure) {
                this.statusMessagesService.showToasterError('Error', res.failureMessage);
                return;
              }
              this.dataChanged = true;
              this.isDateSet = true;
              this.getChanges();
              this.statusMessagesService.showToasterInfo('Saved', res.value);
            },
            error: (err) => {         
              this.statusMessagesService.showHttpError(err);
            },
            complete: () => {         
                this.showLoading = false;
            }
        }
    );
  }

  removeAssignmentExtendDate() {
    this.showLoading = true;

    this.assignmentApi.removeAssignmentExtendDate(new ChangeAssignmentDate(this.assignmentNumber, new Date()))
      .subscribe({
            next: (res: ReturnObject<string>) => {
              if (res.isFailure) {
                this.statusMessagesService.showToasterError('Error', res.failureMessage);
                return;
              }
              this.dataChanged = true;
              this.isDateSet = false;
              this.getChanges();
              this.statusMessagesService.showToasterInfo('Removed', res.value);
            },
            error: (err) => {         
              this.statusMessagesService.showHttpError(err);
            },
            complete: () => {         
                this.showLoading = false;
            }
        }
    );
  }

  closeDialog() {
    this.showMe = false;
    this.onCloseDlg.emit(this.dataChanged);
  }

  showDeleteSymbol(): boolean {
    return this.logChangesList.length > 0 && this.getDateString( this.logChangesList[0].changedTo) != 'No date set';
  }

  getDateString(dateString: string): string {
    return dateString !== '2099-12-31' && dateString !== '12/31/2099'
      ? dateString
      : 'No date set';
  }

  isAllowedToEditExtendDate(): boolean {
    return this.loggedUser.accessFeatures.includes('extendall')
      || (this.loggedUser.accessFeatures.includes('extendown')
        && this.loggedUser.id == this.assignmentManager);
  }

  isValuesSet(): boolean {
    return !this.common.isNullOrWhiteSpace(this.extendtoDate);
  }
}
